import React, { useEffect } from 'react';
import { Card, Row, Col, Statistic } from 'antd';
import { UserOutlined, ShoppingOutlined, DollarOutlined, RiseOutlined, AppstoreOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { getDashboardData } from '../store/slices/dashboardSlice';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

const Dashboard = () => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(getDashboardData())
    }, [dispatch])
    const { dashboardData } = useSelector((state) => state?.dashboard)
    const formatData = (data = []) => {
        return data.map(item => ({
            // name: new Date(0, item._id.month - 1).toLocaleString("en-US", {
            // month: "short"
            // }),
            name: `${new Date(0, item._id.month - 1).toLocaleString("en-US", {
                month: "short"
            })} ${item._id.year}`,
            total: item.totalAmount
        }));
    };
    const chartData = formatData(dashboardData?.data?.transactionPerMonth || []);
    const averageDeliveryTimeChart = dashboardData?.data?.averageDeliveryTime || [];
    const agentRatingData = dashboardData?.data?.agentRatings || []
    const revenuePerAgent = dashboardData?.data?.revenuePerAgent || []
    return (
        <div>
            <h1 style={{ marginBottom: 24 }}>Jobs</h1>
            <Row gutter={[16, 16]}>
                {/* <Col xs={24} sm={12} lg={6}>
                    <Card>
                        <Statistic
                            title="Total Users"
                            value={dashboardData?.data?.users}
                            prefix={<UserOutlined />}
                            valueStyle={{ color: '#3f8600' }}
                        />
                    </Card>
                </Col> */}
                {/* <Col xs={24} sm={12} lg={6}>
                    <Card>
                        <Statistic
                            title="Total Jobs"
                            value={dashboardData?.data?.jobs}
                            prefix={<ShoppingOutlined />}
                            valueStyle={{ color: '#1890ff' }}
                        />
                    </Card>
                </Col> */}
                {/* <Col xs={24} sm={12} lg={6}>
                    <Card>
                        <Statistic
                            title="Revenue"
                            value={dashboardData?.data?.revenue}
                            prefix={<DollarOutlined />}
                            precision={2}
                            valueStyle={{ color: '#cf1322' }}
                        />
                    </Card>
                </Col> */}
            </Row>
            <Row gutter={[16, 16]} style={{marginTop: 12}}>
                <Col xs={24} sm={12} lg={6}>
                    <Card>
                        <Statistic
                            title="Today's Job"
                            value={dashboardData?.data?.todaysJobs}
                            prefix={<AppstoreOutlined />}
                            valueStyle={{ color: '#1e6eee' }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} lg={6}>
                    <Card>
                        <Statistic
                            title="Assigned Jobs"
                            value={dashboardData?.data?.assignedJobs}
                            prefix={<AppstoreOutlined />}
                            valueStyle={{ color: '#1e6eee' }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} lg={6}>
                    <Card>
                        <Statistic
                            title="Un Assigned Jobs"
                            value={dashboardData?.data?.unAssignedJobs}
                            prefix={<AppstoreOutlined />}
                            valueStyle={{ color: '#1e6eee' }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} lg={6}>
                    <Card>
                        <Statistic
                            title="Total Delivered Jobs"
                            value={dashboardData?.data?.deliveredJobs}
                            prefix={<AppstoreOutlined />}
                            valueStyle={{ color: '#1e6eee' }}
                        />
                    </Card>
                </Col>
            </Row>

            <h1 style={{ marginBottom: 24 }}>Users</h1>
            <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} lg={6}>
                    <Card>
                        <Statistic
                            title="Total Agents"
                            value={dashboardData?.data?.agents}
                            prefix={<UserOutlined />}
                            valueStyle={{ color: '#3f8600' }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} lg={6}>
                    <Card>
                        <Statistic
                            title="Total Users"
                            value={dashboardData?.data?.users}
                            prefix={<UserOutlined />}
                            valueStyle={{ color: '#3f8600' }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} lg={6}>
                    <Card>
                        <Statistic
                            title="Total B2B Users"
                            value={dashboardData?.data?.b2bUsers}
                            prefix={<UserOutlined />}
                            valueStyle={{ color: '#3f8600' }}
                        />
                    </Card>
                </Col>
            </Row>

            <h1 style={{ marginBottom: 24 }}>Accounts</h1>
            <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} lg={12}>
                    <Card title="Monthly Transactions">
                        {chartData.length > 0 ? (
                        <ResponsiveContainer width="100%" height={300}>
                            <BarChart data={chartData}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip formatter={(value) => `Rs ${value}`} />
                            <Bar dataKey="total" fill="#B49630" />
                            </BarChart>
                        </ResponsiveContainer>
                        ) : (
                        <p>No data available</p>
                        )}
                    </Card>
                </Col>
            </Row>
            <br></br>
            <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} lg={6}>
                    <Card>
                        <Statistic
                            title="Revenue"
                            value={dashboardData?.data?.revenue}
                            prefix={<DollarOutlined />}
                            precision={2}
                            valueStyle={{ color: '#cf1322' }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} lg={6}>
                    <Card>
                        <Statistic
                            title="Total Transactions"
                            value={dashboardData?.data?.totalTransactions}
                            prefix={<DollarOutlined />}
                            valueStyle={{ color: '#cf1322' }}
                        />
                    </Card>
                </Col>
            </Row>
            <h1 style={{ marginBottom: 24 }}>Notifications</h1>
            <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} lg={6}>
                    <Card>
                        <Statistic
                            title="Total Notifications"
                            value={dashboardData?.data?.totalNotifications}
                            prefix={<DollarOutlined />}
                            valueStyle={{ color: '#f0a44e' }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} lg={6}>
                    <Card>
                        <Statistic
                            title="Sent Notifications"
                            value={dashboardData?.data?.sentNotifications}
                            prefix={<DollarOutlined />}
                            valueStyle={{ color: '#f0a44e' }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} lg={6}>
                    <Card>
                        <Statistic
                            title="Sheduled Notifications"
                            value={dashboardData?.data?.scheduledNotifications}
                            prefix={<DollarOutlined />}
                            valueStyle={{ color: '#f0a44e' }}
                        />
                    </Card>
                </Col>
            </Row>
            <h1 style={{ marginBottom: 24 }}>Agent Performance</h1>
            <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} lg={8}>
                    <Card title="Average Delivery Time (Agents)">
                        {averageDeliveryTimeChart && averageDeliveryTimeChart.length > 0 ? (
                            <ResponsiveContainer width="100%" height={300}>
                            <BarChart data={averageDeliveryTimeChart}>
                                <CartesianGrid strokeDasharray="3 3" />

                                {/* X-axis = Agent Name */}
                                <XAxis dataKey="agentName" />

                                {/* Y-axis = Minutes */}
                                <YAxis />

                                {/* Tooltip */}
                                <Tooltip
                                formatter={(value) => [`${value} min`, "Avg Delivery Time"]}
                                />

                                {/* Bar */}
                                <Bar dataKey="avgDeliveryTime" fill="#B49630" />
                            </BarChart>
                            </ResponsiveContainer>
                        ) : (
                            <p>No data available</p>
                        )}
                    </Card>
                </Col>
                <Col xs={24} sm={12} lg={8}>
                    <Card title="Agent Ratings">
                        {agentRatingData?.length > 0 ? (
                            <ResponsiveContainer width="100%" height={300}>
                            <BarChart data={agentRatingData}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="agentName" />
                                <YAxis domain={[0, 5]} />
                                <Tooltip
                                    formatter={(value, _, props) => [
                                        `${value} ⭐ (${props.payload.totalReviews} reviews)`,
                                        "Rating"
                                    ]}
                                />

                                <Bar dataKey="avgRating" fill="#f59e0b" />
                            </BarChart>
                            </ResponsiveContainer>
                        ) : (
                            <p>No data available</p>
                        )}
                    </Card>
                </Col>
                <Col xs={24} sm={12} lg={8}>
                    <Card title="Revenue Generated per Agent">
                        {revenuePerAgent?.length > 0 ? (
                            <ResponsiveContainer width="100%" height={300}>
                            <BarChart data={revenuePerAgent}>
                                <CartesianGrid strokeDasharray="3 3" />

                                {/* X-axis = Agent Name */}
                                <XAxis
                                    dataKey="agentName"
                                    // interval={0}
                                    // angle={-35}
                                    // textAnchor="end"
                                    // tick={{ fontSize: 12 }}
                                />

                                {/* Y-axis = Revenue */}
                                <YAxis />

                                <Tooltip formatter={(value) => `Rs ${value}`} />

                                <Bar dataKey="totalRevenue" fill="#16a34a" />
                            </BarChart>
                            </ResponsiveContainer>
                        ) : (
                            <p>No data available</p>
                        )}
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default Dashboard;

